import { useAppTabs } from "~stores/useAppTabs.ts";
import { getCurrentInstance, watch, onScopeDispose } from "vue";

window.ontabclose = {};

export interface CloseTabEvent {
	prevent: boolean;
}

export const onActivateTab = (callback: (fullPath: string | null) => unknown) => {
	const node = getCurrentInstance()?.vnode;
	callback(node?.props?.tab?.fullPath);
};

export const onCloseTab = (callback: (event: CloseTabEvent) => unknown) => {
	const node = getCurrentInstance()?.vnode;

	if (node == null) return;
	if (node.props == null) return;
	if (!("tab" in node.props)) {
		console.error("onCloseTab failed because component did not receive 'tab' prop!!");
		return;
	}

	window.ontabclose[node.props.tab.fullPath] = callback;
};

type Notification = {
	type: "SUCCESS" | "WARNING" | "ERROR" | "INFO";
	title: string;
	message: string | null;
};
export function onNotification(callback: (notification: Notification) => void) {
	const onNotif = (event: Event) => {
		if (!(event instanceof CustomEvent)) return;

		const notification = event.detail as Notification;

		callback(notification);
	};
	window.addEventListener("food:notification", onNotif);

	return () => {
		window.removeEventListener("food:notification", onNotif);
	};
}
